import React from 'react';
import styles from './CheckBox.module.css';

const CheckBox = ({ id, label, classes, ...props }) => {
	return (
		<div className='form-check mb-2'>
			<input
				{...props}
				className={`form-check-input ${styles.checkbox} ${classes && classes}`}
				type='checkbox'
				value=''
				id={id}
			/>
			<label className='form-check-label' htmlFor={id}>
				{label}
			</label>
		</div>
	);
};

export default CheckBox;
